import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Text } from '../../../../atoms';
import { StatusBadge } from 'components/StatusBadge/StatusBadge';
import { IMPACT_STATUS_MAP } from '../../constants';
import { EvaluationTableRowProps } from '../../types';
import './style.scss';

export const EvaluationTableRow: React.FC<EvaluationTableRowProps> = ({
  item,
  index,
  onEvaluationClick
}) => {
  const status = IMPACT_STATUS_MAP[item.status];

  const handleActionClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    await onEvaluationClick(index, item);
  };

  return (
    <tr>
      <td data-label="Nome do treinamento">
        <Text component="p" text={item.title} />
      </td>
      <td data-label="Disponibilizado em">
        <Text component="p" text={item.availableAt} />
      </td>
      <td data-label="Expira em">
        <Text component="p" text={item.expiresAt} />
      </td>
      <td data-label="Status">
        <StatusBadge
          size="large"
          variant={undefined}
          rounded
          minimal
          badgeColor={status.badgeColor}
          fontColor={status.fontColor}
          className="status-badge"
          style={{
            backgroundColor: status.badgeColor + '22',
            color: status.fontColor,
          }}
        >
          <span className="impact-evaluation-table-row__status-badge">
            <span
              className="impact-evaluation-table-row__status-icon"
              style={{ color: status.badgeColor }}
            >
              •
            </span>
            {status.label}
          </span>
        </StatusBadge>
      </td>
      <td data-label="Ações">
        <div className="actions">
          <Tooltip title={status.tooltip} placement="top">
            {item.status === 'PENDING' ? (
              <a
                href="#"
                className="impact-evaluation-table-row__action-link"
                style={{ color: status.badgeColor }}
                aria-label="Responder avaliação de impacto"
                onClick={handleActionClick}
              >
                {status.icon}
              </a>
            ) : (
              <span
                className="impact-evaluation-table-row__action-disabled"
                style={{ color: status.badgeColor }}
                aria-label="Avaliação já respondida ou expirada"
              >
                {status.icon}
              </span>
            )}
          </Tooltip>
        </div>
      </td>
    </tr>
  );
};

export default EvaluationTableRow;
